/** Clase para los productos del cliente */
export default class RaterPriceClientProduct {
  /** (String): Código de cliente. */
  clientCode!: string

  /** (String): Código de producto. */
  productCode!: string

  constructor(data: any) {
    this.clientCode = data.clientCode
    this.productCode = data.productCode
  }
}
